<template>
  <modal
    :show.sync="show"
    modal-classes="modal-dialog-centered modal-lg modalflight"
    body-classes="pt-4 pb-2"
    footer-classes="border-top pt-3 pb-3"
    @close="closedModal"
  >
    <template slot="header">
      <h4 class="underline">New Schedule</h4>
    </template>

    <div class="row">
      <div class="col-lg-6 col-sm-9 col-12">
        <WSelect
          placeholder="Select"
          v-model="schedule.driver"
          id="driver"
          name="driver"
          filterable
          v-bind:class="{ 'is-invalid': $v.schedule.driver.$error }"
          label="Driver"
          :error="$v.schedule.driver.$error ? `Select a Driver` : ''"
        >
          <el-option
            v-for="(option, index) in drivers"
            :value="option._id"
            :label="option.first_name + ' ' + option.last_name"
            :key="index"
          ></el-option>
        </WSelect>
      </div>

      <div class="col-lg-2 col-sm-3 col-12 mb-4">
        <label class="title-label-np">Active</label>
        <base-switch v-model="schedule.status"></base-switch>
      </div>

      <div class="col-lg-6 col-sm-6 col-12">
        <WSelect
          label="Working Hours"
          placeholder="Select"
          v-model="schedule.working_hours"
          id="workinghours"
          name="workinghours"
          filterable
          v-bind:class="{ 'is-invalid': $v.schedule.working_hours.$error }"
          :error="
            $v.schedule.working_hours.$error ? `Select a Working Hours` : ''
          "
        >
          <el-option
            v-for="option in workhours"
            :value="option.value"
            :label="option.label"
            :key="option.label"
          ></el-option>
        </WSelect>
      </div>

      <div class="col-lg-6 col-sm-6 col-12">
        <WSelect
          label="Working Days"
          placeholder="Select"
          v-model="schedule.working_days"
          id="workingdays"
          name="workingdays"
          filterable
          v-bind:class="{ 'is-invalid': $v.schedule.working_days.$error }"
          :error="
            $v.schedule.working_days.$error ? `Select a Working Days` : ''
          "
        >
          <el-option
            v-for="option in workdays"
            :value="option.value"
            :label="option.label"
            :key="option.label"
          ></el-option>
        </WSelect>
      </div>

      <div class="col-lg-3 col-sm-6 col-12" v-show="working_hours">
        <base-input label="From Date">
          <flat-picker
            slot-scope="{ focus, blur }"
            @on-open="focus"
            @on-close="blur"
            :config="{
              altFormat: formatDateFlatPicker,
              altInput: true,
              dateFormat: 'Y-m-d',
              allowInput: true
            }"
            class="input-custom"
            v-model="schedule.from_date"
            id="fromdate"
            name="fromdate"
            placeholder="From date"
            @on-change="changeDate"
          ></flat-picker>
        </base-input>
      </div>

      <div class="col-lg-3 col-sm-6 col-12" v-show="working_hours">
        <base-input label="To Date">
          <flat-picker
            slot-scope="{ focus, blur }"
            @on-open="focus"
            @on-close="blur"
            :config="{
              altFormat: formatDateFlatPicker,
              altInput: true,
              dateFormat: 'Y-m-d',
              allowInput: true,
              enable: enable
            }"
            class="input-custom"
            v-model="schedule.to_date"
            id="todate"
            name="todate"
            placeholder="To date"
          ></flat-picker>
        </base-input>
      </div>

      <div class="col-lg-3 col-sm-6 col-12" v-if="working_hours && render">
        <base-input label="From Time">
          <flat-picker
            slot-scope="{ focus, blur }"
            @on-open="focus"
            @on-close="blur"
            :config="{
              altFormat: formatTimeFlatPicker.altFormat,
              enableTime: true,
              noCalendar: true,
              dateFormat: formatTimeFlatPicker.dateFormat,
              time_24hr: formatTimeFlatPicker.time_24hr,
              wrap: true
            }"
            class="input-custom"
            v-model="schedule.from_time"
            id="fromtime"
            name="fromtime"
            placeholder="From Time"
          ></flat-picker>
        </base-input>
      </div>

      <div class="col-lg-3 col-sm-6 col-12" v-if="working_hours && render">
        <base-input label="To Time">
          <flat-picker
            slot-scope="{ focus, blur }"
            @on-open="focus"
            @on-close="blur"
            :config="{
              altFormat: formatTimeFlatPicker.altFormat,
              enableTime: true,
              noCalendar: true,
              dateFormat: formatTimeFlatPicker.dateFormat,
              time_24hr: formatTimeFlatPicker.time_24hr,
              wrap: true
            }"
            class="input-custom"
            v-model="schedule.to_time"
            id="totime"
            name="tomtime"
            placeholder="To Time"
          ></flat-picker>
        </base-input>
      </div>

      <div class="col-lg-12" v-if="view_custom">
        <div class="card mt-2">
          <h4 class="underline">Custom Frecuency</h4>
          <div class="row">
            <div class="col-lg-4 col-sm-12 col-12">
              <label for class="title-label-np">Repeat Every</label>
              <div class="row">
                <div class="col-xl-5 col-sm-4 col-4">
                  <BaseNumberInput
                    v-model.number="schedule.custom.repeat_every"
                    id="schedule_custom_times"
                    name="schedule_custom_times"
                    placeholder="Every"
                  />
                </div>

                <div class="col-xl-7 col-sm-8 col-8">
                  <WSelect
                    placeholder
                    v-model="schedule.custom.repeat_frecuency"
                    id="schedule_custom_frequency"
                    name="schedule_custom_frequency"
                  >
                    <el-option
                      v-for="option in customrepeat"
                      :value="option.value"
                      :label="option.label"
                      :key="option.label"
                    ></el-option>
                  </WSelect>
                </div>
              </div>
            </div>

            <div
              class="col-lg-8 col-sm-12 col-12 mb-4 group-check"
              v-if="schedule.custom.repeat_frecuency === 'week'"
            >
              <label for class="title-label-np">Repeat On</label>
              <button-checkbox
                v-model="schedule.custom.repeat_on.sunday"
                class="d-inline-block btn-check"
                >S</button-checkbox
              >

              <button-checkbox
                v-model="schedule.custom.repeat_on.monday"
                class="d-inline-block btn-check"
                >M</button-checkbox
              >

              <button-checkbox
                v-model="schedule.custom.repeat_on.tuesday"
                class="d-inline-block btn-check"
                >T</button-checkbox
              >

              <button-checkbox
                v-model="schedule.custom.repeat_on.wednesday"
                class="d-inline-block btn-check"
                >W</button-checkbox
              >

              <button-checkbox
                v-model="schedule.custom.repeat_on.thursday"
                class="d-inline-block btn-check"
                >T</button-checkbox
              >

              <button-checkbox
                v-model="schedule.custom.repeat_on.friday"
                class="d-inline-block btn-check"
                >F</button-checkbox
              >

              <button-checkbox
                v-model="schedule.custom.repeat_on.saturday"
                class="d-inline-block btn-check"
                >S</button-checkbox
              >
            </div>
            <div class="col-lg-12">
              <label for class="title-label-np">Ends</label>

              <div class="row">
                <div class="col-lg-4 col-sm-12 col-12">
                  <base-radio
                    class="mr-5 ml-3"
                    name="never"
                    value="never"
                    v-model="schedule.custom.end"
                    >Never</base-radio
                  >
                </div>
              </div>
              <div class="row">
                <div class="col-lg-4 col-sm-4 col-4 align-self-center">
                  <base-radio
                    class="ml-3 mt-2"
                    name="on"
                    value="on"
                    v-model="schedule.custom.end"
                    >On</base-radio
                  >
                </div>
                <div class="col-lg-3 align-self-center">
                  <base-input class="mb-0 mt-2">
                    <flat-picker
                      slot-scope="{ focus, blur }"
                      @on-open="focus"
                      @on-close="blur"
                      :config="{
                        altFormat: formatDateFlatPicker,
                        altInput: true,
                        dateFormat: 'Y-m-d',
                        allowInput: true
                      }"
                      class="input-custom"
                      v-model="schedule.custom.end_on"
                      id="end_on"
                      name="end_on"
                      placeholder="End On"
                    ></flat-picker>
                  </base-input>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-4 col-sm-4 col-4 align-self-center">
                  <base-radio
                    class="ml-3 mt-1"
                    name="after"
                    value="after"
                    v-model="schedule.custom.end"
                    >After Ocurrencies</base-radio
                  >
                </div>
                <div class="col-lg-3 col-sm-6 col-8 align-self-center">
                  <BaseNumberInput
                    v-model.number="schedule.custom.end_after"
                    class="mb-0 mt-1"
                    id="schedule_custom_end_after"
                    name="schedule_custom_end_after"
                    placeholder="Every"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <label class="title-label-np">Color</label>

        <div class="buttons-colors">
          <button-radio-group-colors
            :options="colors"
            v-model="schedule.color"
          ></button-radio-group-colors>
        </div>
      </div>
    </div>

    <div class="border-top pt-3 mt-3">
      <div class="row">
        <div class="col-6 text-left">
          <base-button
            type="outline-neutral"
            class="min-button"
            @click="closedModal"
          >
            <i class="flaticon-cancel"></i> Close
          </base-button>
        </div>
        <div class="col-6 text-right">
          <base-button
            type="primary"
            class="min-button"
            @click="addschedule"
            :disabled="disableButton"
          >
            <i class="flaticon-floppy-disk"></i>Save
          </base-button>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import lodash from "lodash";
import endpoint from "../../Commons/Services/index";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment-timezone";
import { DatePicker, TimeSelect } from "element-ui";
import { required } from "vuelidate/lib/validators";
import WSelect from "@/components/Select";
WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};
export default {
  name: "NewSchedule",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    drivers: {
      type: Array,
      default: []
    },
    selectInfo: {
      type: Object,
      default: null
    },
    origin: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      schedule: {
        driver: this.origin === "single" ? this.drivers[0]._id : "",
        working_hours: "custom",
        working_days: "daily",
        current_shift: false,
        status: true,
        start: moment()
          .utc(true)
          .format("YYYY-MM-DD"),
        from_date: moment()
          .utc(true)
          .format("YYYY-MM-DD"),
        from_time: "12:00",
        to_date: moment()
          .utc(true)
          .format("YYYY-MM-DD"),
        to_time: "19:00",
        custom_frecuency: false,
        color: "sh-blue",
        custom: {
          repeat_every: 1,
          repeat_frecuency: "week",
          repeat_on: {
            monday: moment().day() === 1 ? true : false,
            tuesday: moment().day() === 2 ? true : false,
            wednesday: moment().day() === 3 ? true : false,
            thursday: moment().day() === 4 ? true : false,
            friday: moment().day() === 5 ? true : false,
            saturday: moment().day() === 6 ? true : false,
            sunday: moment().day() === 0 ? true : false
          },
          end: "on",
          end_on: moment()
            .add(3, "month")
            .format("YYYY-MM-DD"),
          end_after: 1
        },
        events: [],
        timezone: ""
      },
      scheduleCopy: null,
      working_hours: true,
      working_days: false,
      view_custom: false,
      show: false,
      enable: [
        moment()
          .utc(true)
          .format("YYYY-MM-DD"),
        moment()
          .add(1, "days")
          .utc(true)
          .format("YYYY-MM-DD")
      ],
      timezone: this.origin === "single" ? this.drivers[0].timezone : "",
      workhours: [
        { value: "full_day", label: "Full Day (7am to 7pm)" },
        { value: "morning", label: "Morning (7am to 4pm)" },
        { value: "evening", label: "Evening (5pm to 08pm)" },
        { value: "night", label: "Night (10pm to 7am)" },
        { value: "custom", label: "Custom" }
      ],
      workdays: [
        { value: "daily", label: "Daily (7 days a week)" },
        { value: "weekdays", label: "Weekdays (M-F)" },
        { value: "weekends", label: "Weekends (Saturday & Sunday)" },
        { value: "custom", label: "Custom" }
      ],
      customrepeat: [
        { value: "day", label: "Day" },
        { value: "week", label: "Week" },
        { value: "month", label: "Month" }
      ],
      colors: [
        { value: "sh-green-lg", color: "sh-green-lg" },
        { value: "sh-green", color: "sh-green" },
        { value: "sh-green-light", color: "sh-green-light" },
        { value: "sh-blue", color: "sh-blue" },
        { value: "sh-blue-purple", color: "sh-blue-purple" },
        { value: "sh-purple", color: "sh-purple" },
        { value: "sh-purple-light", color: "sh-purple-light" },
        { value: "sh-bordo", color: "sh-bordo" },
        { value: "sh-red", color: "sh-red" },
        { value: "sh-orange", color: "sh-orange" },
        { value: "sh-yellow", color: "sh-yellow" },
        { value: "sh-brown-light", color: "sh-brown-light" },
        { value: "sh-bronze", color: "sh-bronze" },
        { value: "sh-brown", color: "sh-brown" }
      ],
      changue: false,
      selectData: null,
      disableButton: false
    };
  },
  created() {
    this.scheduleCopy = lodash.cloneDeepWith(this.schedule);
  },
  watch: {
    value: function(newVal, oldVal) {
      if (!newVal && oldVal) {
        this.$v.schedule.$reset();
        this.show = true;
      } else if (newVal && !oldVal) {
        this.show = true;
      }
    },
    selectInfo: function(newVal, oldVal) {
      if (newVal !== null) {
        this.selectData = lodash.cloneDeepWith(newVal);
        let start = moment(newVal.start)
          .utc(true)
          .format("YYYY-MM-DD");
        let end = moment(newVal.end)
          .utc(true)
          .format("YYYY-MM-DD");
        if (start === end) {
          this.schedule.start = moment(newVal.startStr)
            .utc(true)
            .format("YYYY-MM-DDTHH:mm:ss");
          this.schedule.from_date = moment(newVal.startStr)
            .utc(true)
            .format("YYYY-MM-DDTHH:mm:ss");
          this.schedule.to_date = moment(newVal.endStr)
            .utc(true)
            .format("YYYY-MM-DDTHH:mm:ss");

          this.schedule.from_time = this.getTime(
            moment(newVal.startStr)
              .utc(true)
              .format("YYYY-MM-DDTHH:mm:ss")
          );
          this.schedule.to_time = this.getTime(
            moment(newVal.endStr)
              .utc(true)
              .format("YYYY-MM-DDTHH:mm:ss")
          );
          this.enable = [this.schedule.from_date, this.schedule.to_date];
        } else {
          this.schedule.start = moment(newVal.start)
            .utc(true)
            .format("YYYY-MM-DDTHH:mm:ss");

          this.schedule.from_date = moment(newVal.start)
            .utc(true)
            .format("YYYY-MM-DDTHH:mm:ss");

          this.schedule.to_date = moment(newVal.end)
            .subtract(1, "day")
            .format("YYYY-MM-DDTHH:mm:ss");
          this.enable = [this.schedule.from_date, this.schedule.to_date];
        }
        /*  */
        this.schedule.custom.end_on = moment(newVal.start)
          .utc(true)
          .add(3, "month")
          .format("YYYY-MM-DD");
      }
    },
    "schedule.working_hours": function(newVal, oldVal) {
      if (newVal === "custom") {
        this.working_hours = true;
      } else if (newVal === "full_day") {
        this.schedule.from_time = "07:00";
        this.schedule.to_time = "19:00";
        this.working_hours = false;
        this.schedule.to_date = this.schedule.from_date;
      } else if (newVal === "morning") {
        this.schedule.from_time = "07:00";
        this.schedule.to_time = "16:00";
        this.working_hours = false;
        this.schedule.to_date = this.schedule.from_date;
      } else if (newVal === "evening") {
        this.schedule.from_time = "17:00";
        this.schedule.to_time = "20:00";
        this.schedule.to_date = this.schedule.from_date;
        this.working_hours = false;
      } else {
        this.schedule.from_time = "22:00";
        this.schedule.to_time = "07:00";
        this.schedule.to_date = this.schedule.from_date;
        this.working_hours = false;
      }
    },
    "schedule.working_days": function(newVal, oldVal) {
      if (newVal === "custom") {
        this.view_custom = true;
        this.schedule.custom_frecuency = true;
        this.working_days = true;
      } else {
        this.schedule.custom_frecuency = false;
        this.view_custom = false;
        this.working_days = false;
      }
    },
    "schedule.driver": function(newVal, oldVal) {
      if (newVal !== "") {
        let driver = this.drivers.find(element => element._id === newVal);
        if (driver !== undefined) {
          this.timezone = driver.timezone;
        }
      }
    }
  },
  methods: {
    changeDate(input) {
      if (this.changue) {
        let date = moment(input[0]).utc(true);
        if (
          date.format("YYYY-MM-DD") ===
          moment(this.schedule.to_date)
            .utc(true)
            .format("YYYY-MM-DD")
        ) {
          this.schedule.to_date = date.format("YYYY-MM-DD");
        } else {
          this.schedule.to_date =
            this.selectData !== null
              ? moment(this.selectData.end)
                  .subtract(1, "day")
                  .format("YYYY-MM-DDTHH:mm:ss")
              : date.format("YYYY-MM-DD");
        }
        this.enable = [
          moment(date)
            .utc(true)
            .format("YYYY-MM-DD"),
          moment(date)
            .add(1, "days")
            .utc(true)
            .format("YYYY-MM-DD")
        ];
      } else {
        this.changue = true;
      }
      this.selectData = null;
    },
    async addschedule() {
      try {
        this.disableButton = true;
        this.schedule.timezone = this.timezone;
        this.$v.schedule.$touch();
        let driver = this.drivers.find(
          element => element._id === this.schedule.driver
        );
        if (!this.$v.schedule.$invalid) {
          let schedule = lodash.cloneDeepWith(this.schedule);
          schedule["from_date"] = moment(
            moment(`${schedule.from_date} ${schedule.from_time}`).utc(true)
          )
            .set("hour", moment(schedule.from_time, "h:mm A").get("hour"))
            .set("minute", moment(schedule.from_time, "h:mm A").get("minutes"))
            .utc(true)
            .format("YYYY-MM-DDTHH:mm:ss");

          schedule["to_date"] = moment(
            moment(`${schedule.to_date} ${schedule.to_time}`).utc(true)
          )
            .utc(true)
            .set("hour", moment(schedule.to_time, "h:mm A").get("hour"))
            .set("minute", moment(schedule.to_time, "h:mm A").get("minutes"))
            .format("YYYY-MM-DDTHH:mm:ss");

          schedule.custom.end_on = moment(
            moment(`${schedule.custom.end_on} ${schedule.from_time}`).utc(true)
          )
            .utc(true)
            .set("hour", moment(schedule.from_time, "h:mm A").get("hour"))
            .set("minute", moment(schedule.from_time, "h:mm A").get("minutes"))
            .format("YYYY-MM-DDTHH:mm:ss");
          if (
            moment(schedule.from_date).isSameOrBefore(schedule.to_date, "days")
          ) {
            let response = await this.createdSchedule(schedule);
            if (response.status) {
              this.$notify({
                type: "success",
                title: "Success!",
                message: "Event saved successfully",
                icon: "ni ni-check-bold"
              });
              this.$emit("add", { events: response.schedule.events });
              this.disableButton = false;
              this.closedModal();
              return true;
            } else {
              this.$notify({
                type: "danger",
                title: "Error!",
                message: "The event could not be saved. Please check again.",
                icon: "flaticon-remove"
              });
              this.disableButton = false;
              this.closedModal();
              return false;
            }
          } else {
            this.$notify({
              type: "danger",
              title: "Error!",
              message: "The start date cannot be greater than the end date",
              icon: "flaticon-remove"
            });
            this.disableButton = false;
            return false;
          }
        } else {
          this.disableButton = false;
          return false;
        }
      } catch (error) {
        this.disableButton = false;
        this.closedModal();
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The event could not be saved. Please check again.",
          icon: "flaticon-remove"
        });
        return false;
      }
    },
    async createdSchedule(schedule) {
      try {
        let created = await endpoint.drivers.services.createdSchedule(
          schedule,
          this.sesion.token
        );
        let response = created.data;
        if (response.status) {
          return { status: true, schedule: response.data.schedule };
        } else {
          return { status: true, schedule: null };
        }
      } catch (error) {
        return { status: false, schedule: null };
      }
    },
    deleteschedule() {
      this.$notify({
        type: "success",
        title: "Success!",
        message: "The Schedule has been Deleted",
        icon: "ni ni-check-bold"
      });
    },
    clearschedule() {
      this.schedule = lodash.cloneDeepWith(this.scheduleCopy);
    },
    closedModal() {
      this.show = false;
      this.clearschedule();
    },
    getTime(date) {
      return moment(date)
        .utc(true)
        .format("HH:mm");
    },
    ...mapActions([]),
    ...mapMutations(["setLoad"])
  },
  computed: {
    ...mapGetters(["sesion", "settings"]),
    formatDateFlatPicker: function() {
      if (this.settings) {
        if (this.settings.dateFormat === "DD-MMM-YYYY") {
          return "d-M-Y";
        } else if (this.settings.dateFormat === "DD/MM/YYYY") {
          return "d/m/Y";
        } else {
          return "m/d/Y";
        }
      } else {
        return "d-M-Y";
      }
    },
    formatTimeFlatPicker: function() {
      if (this.settings) {
        if (this.settings.timeFormat === "hh:mm A") {
          return {
            altFormat: "G:i K",
            dateFormat: "G:i K",
            time_24hr: false
          };
        } else {
          return {
            altFormat: "H:i",
            dateFormat: "H:i",
            time_24hr: true
          };
        }
      } else {
        return {
          altFormat: "G:i K",
          dateFormat: "G:i K",
          time_24hr: false
        };
      }
    },
    render: function() {
      if (this.sesion.role === "admin") {
        return true;
      } else {
        return this.settings.status;
      }
    }
  },
  components: {
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    flatPicker,
    WSelect
  },
  validations: {
    schedule: {
      driver: {
        required
      },
      working_hours: {
        required
      },
      working_days: {
        required
      }
    }
  }
};
</script>
